import request from 'utils/request'

/*---------  附件    -------*/
//附件列表
export const getAttachment = data =>
  request().post('customer/attachment/page', data)
//下载
export const downloadRequest = id =>
  request().get(`customer/attachment/download/${id}`, { responseType: 'blob' })
//删除
export const deleteRequest = id =>
  request().get(`customer/attachment/delete/${id}`)
//添加
export const addAssurance = data => request().post('assurance/add', data)
//导出
export const exportAssurance = id => request().get(`assurance/export/${id}`)

export const addDocument = data =>
  request().post('customer/attachment/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
